import ObjectCopyService from "external-services/object-copy-service/index";
import {StatusService} from "external-services/status-service";
import { BookingMethods, ServiceEventType } from "shared-types/SharedTypes";
import {BookingAvailabilityService} from "app/services/LegacyBookingAvailabilityService/index";
import DateUtilsService from 'external-services/date-utils-service';

const NS = 'BookingsCalulationsService'; // jshint ignore:line

export default function BookingsCalulationsService($filter, $q) {
  "ngInject";

  var service = {
    getBookingsCountAtMin: getBookingsCountAtMin,
    getBookingsByTable: getBookingsByTable,
    checkBookingsAtTime: checkBookingsAtTime,
    getScheduleIntervalsWithCovers: getScheduleIntervalsWithCovers
  };

  return service;

  /**
   * Gets an object to be used in the `timeListPopover.component`
   * @param {*} date - JS Date object for current day
   * @param {*} curHoverMin - minute value for cursor's position on the timeline
   * @param {*} bookings - bookings to check
   * @param {*} schedule - schedule for the current day
   * @param {*} curTimeMin - minute value for the red line that represents the current time of the day
   */
  function getBookingsCountAtMin(date, curHoverMin, bookings, schedule, curTimeMin) {
    const results = _getBookingsCountAtMinForEvents(date, curHoverMin, schedule);
    if (bookings) {
      _getBookingsCountAtMinForSchedule(schedule, date, curHoverMin, curTimeMin, bookings, results);
    }

    return results;
  }

  /**
   * Give a list of tables and bookings this will map them to bookings by table
   * @param  {Array} bookings
   * @param  {Array} tables
   * @return {Object} an object of tables with bookings array
   */
  function getBookingsByTable(bookings) {
    // work out date
    // group bookings by table
    var bookingsByTable = {};
    // for (var t = tables.length - 1; t >= 0; t--) {
    //  var table = tables[t];
    //  bookingsByTable[table._id] = {};
    //  bookingsByTable[table._id].table = table;
    //  bookingsByTable[table._id].bookings = [];
    // }
    var bookingsLength = bookings.length;
    for (var b = 0; b < bookingsLength; b++) {
      var booking = bookings[b];
      // set the booking end time

      if (!booking.status) {
        StatusService.populateMissingStatusInBooking(booking);
      }
      if (booking.status && booking.status.statusType !== 'cancelled') {
        // add the booking to its table
        if (booking.tables) {
          for (var i = booking.tables.length - 1; i >= 0; i--) {
            var table = booking.tables[i];
            if (table) {
              if (!bookingsByTable[table._id]) {
                bookingsByTable[table._id] = {
                  table: table,
                  bookings: []
                };
              }
              bookingsByTable[table._id].bookings.push(booking);
            }

          }
        }
      }
    }
    return bookingsByTable;
  }


  function checkBookingsAtTime(time, bookingDate, schedule, service, layouts, requestDuration, requestedPeople, tables, bookingsByTable, preferredSectionId, requiredTableId, allowPassTimes, bookingMethod) {
    // work out the total time
    var startDate = schedule.services[0].startTime;
    var tablesJoins = [];

    for (var r = layouts.length - 1; r >= 0; r--) {
      var layout = layouts[r];
      if (layout.tablesJoins) {
        tablesJoins = tablesJoins.concat(layout.tablesJoins);
      }
    }

    return getBookingInfoAtTime(schedule, time, startDate, service, tablesJoins, requestDuration,
      requestedPeople, tables, bookingsByTable, preferredSectionId, requiredTableId, allowPassTimes, bookingMethod);
  }

  /**
   *
   * @param schedule
   * @param layouts
   * @param tables
   * @param bookingsByTable
   * @returns IScheduleInterval[]
   */
  function getScheduleIntervalsWithCovers(schedule, layouts, tables, bookingsByTable) {

    var scheduleIntervals = [];
    var services = [];
    if (schedule.services) {
      services = ObjectCopyService.angularSafeCopy(schedule.services) // makes a copy so it doesn't mutate the original `schedule.services`
        // .filter(service => service.maxCoversPerInterval) // removed this as no hard to do it on all.
        .sort(function (a, b) {
          return b.maxCoversPerInterval - a.maxCoversPerInterval;
        });
    }

    for (service of services) {
      const intervalsNew = BookingAvailabilityService.calulateBookingTimes(
        schedule, service, layouts, service.bookingDuration, 0, tables, bookingsByTable
      );

      scheduleIntervals = scheduleIntervals.concat(intervalsNew);
    }

    let x = scheduleIntervals.map((interval) => {

      return {
        time: interval.time,
        maxCovers: interval.maxCovers,
        coversReached: interval.coversReached,
        coversReachedAtTime: interval.coversReachedAtTime,
        breached: 0,
        warning: 0
      };
    });


    for (var ii = 0; ii < x.length; ii++) {


      if (x[ii].maxCovers !== null && x[ii].maxCovers <= x[ii].coversReached && x[ii].maxCovers != 0) {

        x[ii].breached = true;

      }

      if (x[ii].maxCovers == 1) {

      }
      if (x[ii].maxCovers - 1 === x[ii].coversReached + 1 - 1) {

        x[ii].warning = true;

      }


    }


    for (var i = 0; i < x.length; i++) {

      for (var j = 0; j < x.length; j++) {

        if (x[i].time.getTime() === x[j].time.getTime()) {

          // detect were not chaging ourself.
          if (i != j) {

            // if()

            if (x[i].breached == 0 && x[j].breached == true) {

              // then swap them over
              x[i].breached = true;
              x[i].maxCovers = x[j].maxCovers;
              x[i].coversReached = x[j].coversReached;

            } else {


              if (x[i].warning == 0 && x[j].warning == true) {

                x[i].warning = true;
                x[i].maxCovers = x[j].maxCovers;
                x[i].coversReached = x[j].coversReached;

              }

            }

          }
        }
      }
    }


    return x;
  }

  function formatDate(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime;
  }


  /*********************************** PRIVATE  *******************************************/

  function getBookingInfoAtTime(schedule, time, startDate, service, tablesJoins, requestDuration, requestedPeople, tables, bookingsByTable, preferredSectionId, requiredTableId, allowPassTimes, bookingMethod) {

    var errorMgs = [];
    var warningMsgs = [];
    // work out the total time
    startDate = schedule.services[0].startTime;
    var serviceStartDate = service.startTime;
    var serviceStartMin = DateUtilsService.dateTimeNum(startDate, serviceStartDate);
    var serviceEndDate = service.endTime;
    var serviceEndMin = DateUtilsService.dateTimeNum(startDate, serviceEndDate);
    // work out the capacity of the restaurant at this time
    var maxCovers = service.maxCoversPerInterval;

    if (service.enableCustomPaxPerIntervals && service.enableCustomPaxPerIntervals == true) {
      for (var bx = service.intervalsCustom.length - 1; bx >= 0; bx--) {
        if (service.intervalsCustom[bx].times == formatDate(time)) {
          if (service.intervalsCustom[bx].values == null || service.intervalsCustom[bx].values == "" || service.intervalsCustom[bx].values === 0) {

            if (service.intervalsCustom[bx].values === 0) {
              maxCovers = 0;
            }
          } else {

            // if (service.intervalsCustom[bx].values === 0) {
            maxCovers = service.intervalsCustom[bx].values;

            // }
          }
        }
      }
    }

    // Check what bookings are on at this time
    var coversReached = 0;
    var coversReachedAtTime = 0;
    var bookingsAtTime = [];
    var bookingsStartingAtTime = [];
    // work out which tables are appropriate
    var requestedStartMin = Math.ceil(DateUtilsService.dateTimeNum(startDate, time));
    var requestedEndMin = requestedStartMin + requestDuration;

    var endTime = new Date(time.getTime());
    endTime.setMinutes(endTime.getMinutes() + requestDuration);

    var vaildTablesAtTime = [];
    var freeTablesAtTime = [];

    var blockedSectionIds = [];
    var blockedTableIds = [];
    // make sure the table is not blocked out
    var totalBlockouts = schedule.blockouts.length;
    for (var b = totalBlockouts - 1; b >= 0; b--) {
      var blockout = schedule.blockouts[b];
      if (DateUtilsService.isInBetweenDates(time, blockout.startDateTime, blockout.endDateTime)) {
        // the time overlaps a block out
        blockedSectionIds = blockedSectionIds.concat(blockout.blockedSections);
        blockedTableIds = blockedTableIds.concat(blockout.blockedTables.map(function (table) {
          return table._id;
        }));
      }
    }

    // make sure the table is not blocked by an event
    for (var e = schedule.services.length - 1; e >= 0; e--) {
      var checkService = schedule.services[e];
      // Check to make sure the service is an event and it does not equal to the current service
      if (checkService.type && checkService.type === 'event' && checkService._id !== service._id) {
        if (endTime.getTime() > checkService.startTime.getTime() && time.getTime() < checkService.endTime.getTime()) {
          // the times over lap
          var sectionsIdUsed = checkService.sectionLayouts.map(function (sectionLayout) {
            return sectionLayout.sectionId;
          });
          blockedSectionIds = blockedSectionIds.concat(sectionsIdUsed);
        }
      }
    }

    var totalTables = tables.length;
    var tableAvailableLookUp = {};
    // @todo: requiredTable needs to have a type (when converting to TS) that extends ITableItem to include `available` and `validTable`. Severity: medium
    var requiredTable;
    var validTable;

    const bookingSlots = [];
    // in case the service is an event type, intervalDuration is informed by the property "boookingInterval" (as it is, with misspelling)
    const bookingIntervalAsPossibleString = (service.type.toLowerCase() == ServiceEventType.Event.toLowerCase()
      ? service.boookingInterval
      : service.intervalsCustom && service.intervalsCustom.length ? service.intervalsCustom[0].intervalDuration : 0);
    const bookingInterval = typeof bookingIntervalAsPossibleString === "string" ? parseInt(bookingIntervalAsPossibleString) : bookingIntervalAsPossibleString;

    // configure the number of booking slots
    if (requestedEndMin > 0 && bookingInterval > 0) {
      const serviceDuration = service.duration || service.bookingDuration; // could be either (both values mean same thing - duration of the service)
      const reqIntervals = (serviceDuration/bookingInterval) + 1;

      for (var i = 0; i < reqIntervals; i++) {
        let requestSliceEnd = requestedStartMin + (bookingInterval * (i+1));
        if (requestSliceEnd <= requestedEndMin) {
          bookingSlots.push(0);
        }
        else {
          break;
        }
      }
    }

    for (var f = totalTables - 1; f >= 0; f--) {
      var table = tables[f];
      var tableId = table._id;
      var tableObj = bookingsByTable[tableId];
      var tableBookings = (tableObj) ? tableObj.bookings : [];

      validTable = false;

      // cleans bookingSlot array if the table type is shared
      if (table.shared) {
        bookingSlots.forEach((item, j) => {
          bookingSlots[j] = 0;
        });
      }


      // does the table have the right amout of capacity
      // Is the table in the right section
      if (
        (bookingMethod !== BookingMethods.phone || (bookingMethod !== BookingMethods.walkin && !table.walkinOnly)) &&
        (table.capacity >= requestedPeople || table.shared) &&
        (requestedPeople >= table.minCapacity)

        /**
         * If a specific section is selected, this will make tables in other sections orange ("free", but not "valid")/
         */
        && (preferredSectionId === 'any' || preferredSectionId === table.sectionId)

        /**
         * @todo: If diary timeline interval is clicked, this will correspond to the table dropdown next to the status bar,
         * which selects the clicked table. That then makes other tables orange in the same section, unless the table dropdown
         * is set to auto. This is a bit confusing and I think should be removed.
         * Severity: medium
         */
        && (!requiredTableId || requiredTableId === 'auto' || requiredTableId === table._id)
      ) {
        validTable = true;
      }

      // table is approiate
      var available = false;
      // does the table have any bookings at all
      if (!tableBookings.length) {
        available = true;
      }

      // loop over the booking to find a gap
      var totalTableBookings = tableBookings.length;
      for (var t = 0; t < totalTableBookings; t++) {
        var booking = tableBookings[t];

        var bookingStartMin = Math.ceil(DateUtilsService.dateTimeNum(startDate, booking.time));
        var bookingEndMin = Math.ceil(DateUtilsService.dateTimeNum(startDate, booking.bookingEnd));


        // if the table is valid check for free space
        // can the request booking fit before this one
        if (t === 0 && requestedStartMin < bookingStartMin && requestedEndMin <= bookingStartMin) {
          available = true;
        }
        // can the request booking fit after this one
        var startGap = bookingEndMin;
        var endGap = false;
        if (t < tableBookings.length - 1) {
          // change the gap end start of the next booking if there is one
          endGap = DateUtilsService.dateTimeNum(startDate, tableBookings[t + 1].time);
        }

        if (requestedStartMin >= startGap) {
          if (endGap) {
            if (requestedEndMin <= endGap) {
              available = true;
            }
          } else if (endGap === false) {
            available = true;
          }
        }

        var index;
        if (bookingStartMin <= requestedStartMin && requestedStartMin < bookingEndMin) {
          // check booking is not a copy
          index = bookingsAtTime.map(function (e) {
            return e._id;
          }).indexOf(booking._id);
          // make sure the booking is not already in the array
          if (index === -1 && booking) {

            // Added  hot fix for display triggering custom itnervals

            if (booking.serviceId == service._id) {
              coversReached += booking.people;


            }
            bookingsAtTime.push(booking);
          }
        }

        if (bookingStartMin === requestedStartMin) {
          // check booking is not a copy
          index = bookingsStartingAtTime.map(function (e) {
            return e._id;
          }).indexOf(booking._id);
          // make sure the booking is not already in the array
          if (index === -1 && booking) {
            if (booking.serviceId == service._id) {
              coversReachedAtTime += booking.people;

              bookingsStartingAtTime.push(booking);
            }
          }
        }

        // Shared table verification - count booking.people by slot intervals
        // (checks if any of tables assigned to the booking is shared type in case of having joinned tables)
        if (booking.tables.some(t => t.shared)) {
          if (bookingStartMin >= requestedStartMin && bookingStartMin < requestedEndMin || bookingEndMin > requestedStartMin && bookingEndMin <= requestedEndMin || bookingStartMin <= requestedStartMin && bookingEndMin > requestedEndMin) {
            if (bookingSlots && bookingSlots.length > 0) {
              bookingSlots.forEach((item, j) => {
                var slotStartTime = requestedStartMin + (bookingInterval * j);
                var slotEndTime = requestedStartMin + (bookingInterval * (j+1));
                if (bookingStartMin <= slotStartTime && slotEndTime <= bookingEndMin) {
                  bookingSlots[j] += booking.people;
                }
              });
            }
          }
        }
      }

      // Gets the maximum of people that will be booked on any interval
      let maxCoversOnSlots = (bookingSlots && bookingSlots.length > 0 ? Math.max(...bookingSlots) : 0);

      // check if the table is shared and it has enough covers left
      if (table.shared && ((table.capacity - maxCoversOnSlots) >= requestedPeople)) {
        available = true;
      } else if (table.shared) {
        validTable = false;
      }

      // make sure table is not blocked
      var blockedTable = false;
      if (available && blockedTableIds.indexOf(table._id) !== -1 || blockedSectionIds.indexOf(table.sectionId) !== -1) {
        available = false;
        blockedTable = true;
      }

      // make sure the table is not for walk-ins only
      var walkinTable = false;
      if (available && bookingMethod !== BookingMethods.walkin && table.walkinOnly) {
        available = false;
        walkinTable = true;
      }
      if (available && validTable && !blockedTable) {
        vaildTablesAtTime.push(table);
      }

      if (available) {
        freeTablesAtTime.push(table);
      }
      tableAvailableLookUp[table._id] = {
        table: table,
        available: available,
        walkinTable: walkinTable
      };

      if (requiredTableId === table._id) {
        requiredTable = ObjectCopyService.angularSafeCopy(table);
        requiredTable.validTable = validTable;
        requiredTable.available = available;
      }
    }

    // work out what joins are free
    var totalJoinTables = tablesJoins ? tablesJoins.length : 0;
    var vaidJoinsAtTime = [];
    for (var j = totalJoinTables - 1; j >= 0; j--) {
      validTable = false;
      var tablesJoin = tablesJoins[j];

      if ((bookingMethod !== BookingMethods.phone || (bookingMethod !== BookingMethods.walkin && !tablesJoin.walkinOnly)) && tablesJoin.capacity >= requestedPeople && requestedPeople >= tablesJoin.minCapacity) {
        validTable = true;
      }
      if (validTable) {
        var joinAvailable = true;
        var totalJoins = tablesJoin.tables.length;
        var tablesList = [];
        var tableNames = [];
        for (var c = 0; c < totalJoins; c++) {
          var tableLookUp = tableAvailableLookUp[tablesJoin.tables[c]];
          if (tableLookUp) {
            tablesList.push(tableLookUp.table);
            tableNames.push(tableLookUp.table.name);
            // if table unavailable and not because it's reserved for walkins, or it's not in a preferred section then the join is unavailable
            if ((!tableLookUp.available && !tableLookUp.walkinTable) || (preferredSectionId !== 'any' && preferredSectionId !== tableLookUp.table.sectionId)) {
              // one of the tables are not available
              joinAvailable = false;
              break;
            }
          }

        }
        if (joinAvailable) {
          // note: this may get called 3 or 4 times before getting added
          tablesJoin.tablesList = tablesList;
          tablesJoin.name = tableNames.sort().join('-');
          vaidJoinsAtTime.push(tablesJoin);
        }
      }
    }

    var status = 'available'; // @todo: use type TimeStatus when converting to TS. Severity: medium

    if (vaildTablesAtTime.length === 0 && vaidJoinsAtTime.length === 0) {
      errorMgs.push('No tables available.');
    }
    if (errorMgs.length) {
      status = 'unavailable';
    }
    if (requiredTable) {
      errorMgs = [];
      warningMsgs = [];
      if (!requiredTable.available) {
        errorMgs.push('T' + requiredTable.name + ' is not available.');
      }
      if (!requiredTable.validTable) {
        if (requestedPeople > requiredTable.capacity) {
          warningMsgs.push('The capacity of T' + requiredTable.name + ' is ' + requiredTable.capacity + '.');
        }
        if (requestedPeople < requiredTable.minCapacity) {
          warningMsgs.push('The min capacity of T' + requiredTable.name + ' is ' + requiredTable.minCapacity + '.');
        }
      }
    }


    if ((maxCovers || maxCovers === 0) && (coversReachedAtTime + requestedPeople) > maxCovers) {


      warningMsgs.push('You have reached your maximum covers at this time');
    }
    if (requestedEndMin > serviceEndMin) {
      //  warningMsgs.push('This booking ends after ' + service.name + ' has finished.');
    }


    if (time.getTime() > service.lastBookingTime.getTime()) {
      warningMsgs.push('This booking starts after your last booking time ' + $filter('date')(service.lastBookingTime, 'hh:mm a').toLowerCase());
    }

    var open = true;
    if (requestedStartMin < serviceStartMin) {
      open = false;
    } else if (requestedStartMin > serviceEndMin) {
      open = false;
    }
    if (!open) {
      warningMsgs = [];
      errorMgs = ['You are closed at this time.'];
    }
    if (service.maxBookingsPerInterval && service.maxBookingsPerInterval !== 0 && bookingsStartingAtTime.length >= service.maxBookingsPerInterval) {
      warningMsgs.push('You have reached your maximum bookings at this time');
    }
    if (!open) {
      vaildTablesAtTime = [];
      freeTablesAtTime = [];
    }
    // add to the list of bookings times

    return {
      time: time,
      maxCovers: maxCovers,
      coversReached: coversReachedAtTime,
      bookingsAtTime: bookingsAtTime,
      vaildTablesAtTime: vaildTablesAtTime,
      freeTablesAtTime: freeTablesAtTime,
      vaidJoinsAtTime: vaidJoinsAtTime,
      status: status, // @todo: make of type TimeStatus (when converting to TS)
      errorMgs: errorMgs,
      warningMsgs: warningMsgs,
      open: open,
      service: service.name,
    };

  }


  function _bookingIsValid(booking) {
    return booking.status && booking.status.statusType !== 'cancelled' && (booking.tables && booking.tables.length);
  }

  function _getBookingsCountAtMinForEvents(date, curHoverMin, schedule) {

    var results = _getEmptyBookingsCountObject();
    var functionEvents = [];

    if (schedule) {
      functionEvents = schedule.services.filter(s => s.type === 'event' && s.eventType === 'PrivateFunction');
    }

    functionEvents.forEach(pf => {
      var startMin = DateUtilsService.minsBetweenDates(date, pf.firstBookingTime);
      var endMin = DateUtilsService.minsBetweenDates(date, pf.endTime);
      if (curHoverMin >= startMin && curHoverMin <= endMin) {
        results.bookings++;
        results.covers += Number(pf.people);
      }
    });

    return results;
  }

  function _getBookingsCountAtMinForSchedule(schedule, date, curHoverMin, curTimeMin, bookings, _results) {

    const results = _results || _getEmptyBookingsCountObject();
    const latestEndDate = _getLatestEndTime(schedule);
    const isOld = curHoverMin < curTimeMin; // don't care about setting old seated info
    const intervalDurMin = parseInt(schedule.boookingInterval, 10);
    const scheduleStartTimeMin = _getEarlistServiceStartTimeInMins(schedule);
    const startOfIntervalMin = _getCurrentIntervalStartMin(scheduleStartTimeMin, intervalDurMin, curHoverMin);
    const endOfIntervalMin = startOfIntervalMin + intervalDurMin;

    bookings.forEach(b => {
      let bookingStartMin = DateUtilsService.minsBetweenDates(date, b.time);
      let bookingEndMin = DateUtilsService.minsBetweenDates(date, b.bookingEnd);
      if (_bookingIsValid(b)) {

        if (_isValidForCovers(curHoverMin, bookingStartMin, bookingEndMin)) {
          results.bookings++;
          results.covers += b.people;
          if (b.status.statusType === 'seated') {
            results.seated += b.people;
          }
        }

        if (!isOld && _isValidForDue(curHoverMin, bookingEndMin, b.bookingEnd, latestEndDate, b.status.statusType)) {
          results.due += b.people;
        }

        if (_isValidForIntervalCovers(bookingStartMin, startOfIntervalMin, endOfIntervalMin)) {
          results.intervalCovers += b.people;
        }
      }
    });

    return results;
  }

  // checks if booking is valid for adding to the 'covers' total for current interval popover
  function _isValidForCovers(curHoverMin, bookingStartMin, bookingEndMin) {
    return curHoverMin >= bookingStartMin && curHoverMin <= bookingEndMin;
  }

  // checks if booking is valid for adding to the 'due' total for current interval popover
  function _isValidForDue(curHoverMin, bookingEndMin, bookingEndDate, latestEndDate, statusType) {
    return statusType !== 'finished' && statusType !== 'seated' && curHoverMin <= bookingEndMin && bookingEndDate <= latestEndDate;
  }

  // checks if booking is valid for adding to the 'intervalCovers' total for current interval popover
  function _isValidForIntervalCovers(bookingStartMin, startOfIntervalMin, endOfIntervalMin) {
    return bookingStartMin >= startOfIntervalMin && bookingStartMin < endOfIntervalMin;
  }

  function _getEmptyBookingsCountObject() {
    return {
      bookings: 0,
      covers: 0,
      seated: 0,
      due: 0,
      intervalCovers: 0
    };
  }

  /**
   * Trawls services in schedule and returns the earliest start time
   */
  function _getEarlistServiceStartTimeInMins(schedule) {
    if (!schedule.services && !schedule.services.length) {
      return null;
    }
    let earliest = schedule.services[0].startTime;
    schedule.services.forEach((s, i) => {
      if (i > 0 && s.startTime < earliest) {
        earliest = s.startTime;
      }
    });

    var min = (earliest.getHours() * 60) + earliest.getMinutes();
    return min;
  }

  /**
   * Returns the current interval start time in minutes
   * @param {*} min - interval start minute
   * @param {*} intervalDurMin - interval duration
   * @param {*} curHoverMin - minute value for cursor's position on the timeline
   */
  function _getCurrentIntervalStartMin(min, intervalDurMin, curHoverMin) {
    if (curHoverMin === min) { // if exact match return it
      return min;
    } else if (curHoverMin < min) { // if start minute is more than current, return the interval start time before it
      return min - intervalDurMin;
    } else {
      return _getCurrentIntervalStartMin(min + intervalDurMin, intervalDurMin, curHoverMin); // cycle until match
    }
  }

  function _getLatestEndTime(schedule) {
    let latestDate = 0;
    schedule.services.forEach(s => {

      if (s.endTime > latestDate) {
        latestDate = s.endTime;
      }
    });
    return latestDate;
  }
}
